var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 20,
    viewBox: "0 0 102 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1614 9.68602C64.4938 7.3148 67.5958 0.359959 69.3613 1.47565C82.1605 9.56385 95.6219 7.47689 97.0665 7.86395C98.511 8.25102 105.087 12.6012 96.3472 14.4005C87.6077 16.1999 70.4958 12.65 67.1614 9.68602Z",
    className: "Brows"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.364 9.68602C37.0316 7.31481 33.9296 0.359962 32.1641 1.47566C19.3649 9.56385 5.90346 7.47689 4.45892 7.86395C3.01437 8.25102 -3.56131 12.6012 5.1782 14.4005C13.9177 16.1999 31.0296 12.65 34.364 9.68602Z",
    className: "Brows"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsH);
export default __webpack_public_path__ + "static/media/Brows H.48b0f89885246ab9f50708bfd431a83b.svg";
export { ForwardRef as ReactComponent };